import { additionalOffers } from '../../util/additional-offers'
import StaticListItem from '../ListItem/StaticListItem'

function StaticOffers() {
    return(
        <>
            <h2>Additional Offers</h2>
            <p>Compare checking rates from across the country</p>
            {additionalOffers.map(offer => {
                const key = Math.floor(Math.random() * 1000)

                return (
                    <StaticListItem 
                        id={key}
                        key={key}
                        name={offer.institution.name}
                        apy={offer.apy}
                        effective_at={offer.effective_at}
                        member={offer.institution.insurance_information.type}
                        min_to_open={offer.min_to_open}
                        balanceToAvoidFees={offer.fees.min_to_avoid_fees}
                        rating={offer.institution.reviews.overall_rating}
                    />
                )
            })}
        </>
    )
}

export default StaticOffers